import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../../helpers/utility';

const initialState = {
  isSidebarOpened: false,
};

const toggleSidebar = (state, action) => {
  return updateObject(state, {isSidebarOpened: !state.isSidebarOpened});
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_SIDEBAR:
      return toggleSidebar(state, action);
    default:
      return state;
  }
};

export default reducer;
